import { render } from "./SendContractorList.vue?vue&type=template&id=255dec98&scoped=true"
import script from "./SendContractorList.vue?vue&type=script&lang=js"
export * from "./SendContractorList.vue?vue&type=script&lang=js"

import "./SendContractorList.vue?vue&type=style&index=0&id=255dec98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255dec98"]])

export default __exports__